// extracted by mini-css-extract-plugin
export var banner = "_qi-0";
export var settingRow = "_qi-2";
export var titleIcon = "_qi-1";